import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes,
  PreloadingStrategy,
  PreloadAllModules,
} from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { LoginComponent } from './shared/components/login/login.component';
import { AccountInfoComponent } from './shared/components/account-info/account-info.component';
import { ForgetPasswordComponent } from './shared/components/forget-password/forget-password.component';
import { UpdatePasswordComponent } from './shared/components/update-password/update-password.component';
import { SecureInnerPagesGuard } from './core/guards/secure-inner.guard';
import { TestComponent } from './shared/components/test/test.component';
import { VerifyOtpComponent } from './shared/components/verify-otp/verify-otp.component';
import { ChangePasswordComponent } from './shared/components/change-password/change-password.component';
import { MagicLoginComponent } from './shared/components/magic-login/magic-login.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  // {
  //   path: 'login',
  //   component: LoginComponent,
  //   pathMatch: 'full',
  //   canActivate: [SecureInnerPagesGuard],
  // },
  {
    path: 'login',
    component: MagicLoginComponent,
    pathMatch: 'full',
    canActivate: [SecureInnerPagesGuard],
  },
  {
    path: 'magic-login',
    loadChildren: () =>
      import(
        './shared/components/magic-verifcation/magic-verifcation.module'
      ).then((m) => m.MagicVerifcationModule),
  },
  {
    path: 'forget-password',
    component: ForgetPasswordComponent,
    pathMatch: 'full',
  },
  {
    path: 'update-password',
    component: UpdatePasswordComponent,
    pathMatch: 'full',
  },
  { path: 'account-info', component: AccountInfoComponent, pathMatch: 'full' },
  { path: 'verify_otp', component: VerifyOtpComponent, pathMatch: 'full' },
  {
    path: 'reset-password',
    component: ChangePasswordComponent,
    pathMatch: 'full',
    canActivate: [SecureInnerPagesGuard],
  },

  { path: 'test', component: TestComponent, pathMatch: 'full' },

  {
    path: '',
    loadChildren: () =>
      import('./modules/user/layout.module').then((m) => m.LayoutModule),
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
